import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // Initialize i18n
import App from "@/App";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";
import logger from "@/utils/logger";
import { startAutoUpdate } from "@/pwa/autoUpdate";
import UpdateReadyBar from "@/pwa/UpdateReadyBar";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
      <UpdateReadyBar />
    </AppErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    logger.log('[Chain29] App ready for offline use');
  },
  onUpdate: (registration) => {
    logger.log('[Chain29] New version available');
    // Optionally show update prompt to user
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  }
});

// Keep every open app (POS, KDS, kiosk, ...) on the deployed build
startAutoUpdate();
